import * as React from 'react';
import { Section, Viewer } from '../../modules';
import { Stationcategory, StationcategoryFactory, Station } from '../../resource/'; 
import { RouteComponentProps } from 'react-router';
import { IAuthProps } from '../../services/Auth';

import { Tabs } from '@independent-software/typeui/controls/Tabs';
import { ToastService } from '@independent-software/typeui/controls/Toast';
import { Flex } from '@independent-software/typeui/controls/Flex';
import { Header } from '@independent-software/typeui/controls/Header';
import { Output } from '../../controls/Output';
import { Label } from '@independent-software/typeui/controls/Label';
import { ListStations } from '../Station';

class ViewStationcategory extends React.Component<IAuthProps & RouteComponentProps<{id:string}>, {}> {

  private handleStationClick = (station: Station) => {
    this.props.history.push(`/stations/${station.id}`);
  }

  render() {
    let p = this.props;
    return (
      <Viewer<Stationcategory> 
        auth={p.auth}
        id={parseInt(p.match.params.id)}
        factory={StationcategoryFactory}
        canEdit={(item: any) => false}
        canDelete={(item: any) => false}
        onEdit={null}
        onDelete={null}
        content={(stationcategory: Stationcategory) => 
          <React.Fragment>
            <Section dark padded>
              <Header size="h1">{stationcategory.name}</Header>
            </Section>
            <Tabs underlined>
              <Tabs.Pane label="General">
                <Section padded="very">
                  <Flex.Columns count={2}>
                    <>
                      <Output label="Name" hint="Stationcategory name">{stationcategory.name}</Output>
                    </>
                    <>
                    </>
                  </Flex.Columns>
                </Section>
              </Tabs.Pane>
              <Tabs.Pane label={<span>Stations <Label size="small">{stationcategory.stations_count}</Label></span>}>
                <ListStations stationcategoryId={stationcategory.id} name="stationcategory_stations" auth={p.auth} onClick={p.auth.hasRight('can_view_stations') && this.handleStationClick}/>
              </Tabs.Pane>
            </Tabs>
          </React.Fragment>}>
      </Viewer>
    );
  }
}

export { ViewStationcategory };
